import { create } from 'zustand';

type LayoutStore = {
  drawerOpen: boolean;
  toggleDrawer: () => void;
  handleDrawerClose: () => void;
};

export const useLayoutStore = create<LayoutStore>()((set) => ({
  drawerOpen: false,
  toggleDrawer: () => set((state) => ({ drawerOpen: !state.drawerOpen })),
  handleDrawerClose: () => set({ drawerOpen: false }),
}));
